<template>
    <div class="col l4 m6 s12">
    <div class="header_text">
    <router-link :to="'/nihom-sub-type/'+data.id">
            <h6>{{ data.name }}</h6>
    </router-link>
    </div>
    <div class="body_box">
        <div class="card card-content" v-for="item in data.nihom_sub_type">
            <router-link :to="'/nihom-content/'+item.id"><p>{{ item.name }}</p></router-link>
        </div>
    </div>
    </div>
</template>
<script>
export default {
    props:["data"],
}
</script>
<style lang="scss" scoped>
   @import "@/style/colors.scss";
        .header_text 
        {
            border-bottom: 2px solid $primaryColor;
            text-align: center;
            margin-bottom: 20px;
            h6 
            {
                color:$primaryColor;
            }
            
        }

        .card 
        {
            padding:10px;
            border-left:10px solid $primaryColor;
            border-radius: 20px;
            text-align: center;
            cursor: pointer;
            color:$primaryColor !important;
        }

        .card:hover 
        {
            transition: 5s;
            transform:scale(1.2);
        }
</style>